<template>
    <svg :width="size" :height="size" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M14.6 37a3.295 3.295 0 0 1-5.216-2.16 7.41 7.41 0 0 0-6.224-6.224A3.295 3.295 0 0 1 1 23.401a7.41 7.41 0 0 0 0-8.802 3.295 3.295 0 0 1 2.16-5.215A7.41 7.41 0 0 0 9.384 3.16 3.295 3.295 0 0 1 14.599 1a7.41 7.41 0 0 0 8.802 0 3.295 3.295 0 0 1 5.215 2.16 7.41 7.41 0 0 0 6.224 6.224A3.295 3.295 0 0 1 37 14.599a7.41 7.41 0 0 0 0 8.802 3.295 3.295 0 0 1-2.16 5.215 7.41 7.41 0 0 0-6.224 6.224A3.295 3.295 0 0 1 23.401 37a7.41 7.41 0 0 0-8.802 0z" fill="#E75300"/>
        <path d="M13.581 23.99c-2.35-.272-2.83-2.843-1.794-5.88 1.069-3.185 4.058-7.333 6.642-6.894 1.707.297 2.358 2.42 2.835 3.904.2.67.481 1.743.464 1.965-.015.184-.157.434-.274.614-2.68 4.058-5.807 6.548-7.873 6.291m13.298-2.252c-.162-.478-.403-1.134-.855-2.492-.13-.406-.24-.79-.37-1.225.2-.31.446-.665.669-1.003 1.621-2.48 3.542-5.454 4.598-7.053h-4.346c-.605.913-1.484 2.236-2.364 3.572-.72-2.368-2.524-3.929-5.016-4.104-3.325-.24-9.062 2.21-11.194 8.328-1.973 5.663 2.3 8.084 5.568 8.252 3.237.16 7.088-1.275 9.678-4.492.1.31.216.691.32.983.623 1.951 1.848 3.134 3.906 3.382 2.63.32 4.236-1.701 4.236-1.701-2.426.263-3.99-.052-4.83-2.447" fill="#FFF"/>
    </g>
    </svg>
</template>
<script>
export default {
    name: "IconRegistered",
    props: {
        size: {
            type: Number,
            default: 24,
        }
    }
};
</script>